import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { consentCancelModalData } from '../../data/modalContentData'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import Headings from '../../components/Headings'
import FooterText from '../../components/PageFooter/FooterText'
import Callout from '../../components/Callout'
import PageFooter from '../../components/PageFooter'
import PageModal from '../../components/PageModal'
import DirectionLink from '../../components/DirectionLink'

const AccessPeriod = () => {
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)
  const [navModalBtnFocused, setNavModalBtnFocused] = useState(false)
  useEffect(() => {
    if (navModalBtnFocused) {
      setNavModalBtnFocused(false)
    }
  }, [navModalBtnFocused])
  function closeModal() {
    setOpenModal(false)
    setNavModalBtnFocused(true)
  }

  const pageModalData = {
    isOpen: openModal,
    onClose: () => closeModal(),
    data: {
      ...consentCancelModalData,
      leftButton: 'No',
      leftButtonFunc: () => closeModal(),
      rightButton: 'Yes',
      rightButtonFunc: () => navigate('/cancel-alert'),
      isModalBtn: false,
    },
  }
  const pageFooterData = {
    leftButton: 'Cancel',
    leftButtonFunc: () => setOpenModal(!openModal),
    navModalBtnFocused: navModalBtnFocused,
    rightButton: 'Continue',
    rightButtonFunc: () => navigate('/share-data'),
    haveShadow: true,
    leftButtonLabel:
      'cancel button, to open the cancel process modal doubleclick here',
    rightButtonLabel: 'continue button, to visit next page  double click here',
  }

  const footerText = (
    <p>
      We will collect and use your data daily on an ongoing basis for 12 months.
    </p>
  )
  return (
    <PageWrapper isModalOpen={pageModalData.isOpen}>
      <Helmet>
        <title>Access period</title>
      </Helmet>
      <PageContentWrapper isModalOpen={pageModalData.isOpen}>
        <DirectionLink
          direction="left"
          link="/your-data"
          text="Back"
          isDepenednt={true}
          isFocused={!pageModalData.isOpen}
          description="Back button, to visit previous page double click here."
        ></DirectionLink>
        <Headings level="h1" text="Access period"></Headings>
        <FooterText content={footerText} isDepenednt={true} />
        <Callout text="01 June 2022 - 31 May 2023" />
      </PageContentWrapper>

      <PageFooter {...pageFooterData} />
      <PageModal {...pageModalData} />
    </PageWrapper>
  )
}

export default AccessPeriod
